module.exports = __webpack_public_path__ + "static/media/VideoModal.833b35e1.css";